// Astryx styles: reset, then theme tokens. Component CSS is NOT imported —
// astryxStylex() resolves core from source and compiles its StyleX into the
// aggregated sheet, so importing the pre-built astryx.css would double it.
import "@astryxdesign/core/reset.css";
import "@astryxdesign/theme-neutral/theme.css";
import { Theme } from "@astryxdesign/core/theme";
import { neutralTheme } from "@astryxdesign/theme-neutral/built";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "@/App";
import { Auth0ProviderWithNavigate } from "@/services/auth0/auth";
import { SessionProvider } from "@/services/auth0/session";
import "@/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

// Astryx toasts run through useToast(), which self-mounts a viewport on first
// use (ToastViewport isn't re-exported from the core barrel).
createRoot(rootEl).render(
  <StrictMode>
    <Theme theme={neutralTheme}>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <QueryClientProvider client={queryClient}>
            <SessionProvider>
              <App />
            </SessionProvider>
          </QueryClientProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </Theme>
  </StrictMode>
);
